module.exports = __webpack_public_path__ + "img/item2.c8749413.png";